import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from 'lucide-react';
import { RelatedArticles } from './realatedArticle';
export const HomeScreen = ({ startTest, relatedArticles }) => {
  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '32px'
    },
    title: {
      fontSize: '36px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '16px',
      textAlign: 'center'
    },
    subtitle: {
      fontSize: '18px',
      color: '#4b5563',
      marginBottom: '24px',
      textAlign: 'center'
    },
    button: {
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      padding: '12px 32px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.2s'
    },
    buttonHover: {
      backgroundColor: '#1d4ed8'
    },
    sectionTitle: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#9d174d',
      marginBottom: '16px'
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
      {/* Left Side - Test Section */}
      <div style={{ flex: '2 1 0%', minWidth: 0 }}>
        <div style={styles.card}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h1 style={styles.title}>Prep Yourself for Depreciation</h1>
            <p style={styles.subtitle}>YoungWorks Self Assessment Tools for Self Analysis and Compensation</p>
            <div style={{ 
              backgroundColor: '#1f2937', 
              color: 'white', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              display: 'inline-block', 
              marginBottom: '32px'
            }}>
              Get Started from 2023
            </div>
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <button 
              onClick={startTest}
              style={styles.button}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
            >
              Start Test
            </button>
          </div>
          
          <div style={{ marginTop: '48px' }}>
            <h2 style={styles.sectionTitle}>Self Assessment Tests</h2>
            <p style={{ color: '#4b5563', marginBottom: '24px' }}>
              Each test is of 2 sessions with detailed solutions. Test your performance against benchmark data points and boost your confidence and balance probability.
            </p>
            
            <h3 style={styles.sectionTitle}>How to Interpret Your Performance Metrics</h3>
            <p style={{ color: '#4b5563' }}>
              We are confident in ensuring that every individual's ownership was able to understand the future, which has to hold your results effectively and why you don't perform any spare work or need help, including a reward indicator.
            </p>
          </div>
        </div>
      </div>
      
      {/* Right Side - Related Articles */}
      <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
        <RelatedArticles articles={relatedArticles} />
      </div>
    </div>
  );
};